// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlipayCircleFilledSvg from "@fishx/icons-svg/es/asn/AlipayCircleFilled";
import FishxIcon from '../components/FishxIcon';

var AlipayCircleFilled = function AlipayCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlipayCircleFilledSvg
  }));
};

AlipayCircleFilled.displayName = 'AlipayCircleFilled';
export default React.forwardRef(AlipayCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlipayCircleFilled.js
// module id = 1966
// module chunks = 0